var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 22H27.5C27.75 22 28 21.8125 28 21.5V6.5C28 6.25 27.75 6 27.5 6H26.5C26.1875 6 26 6.25 26 6.5V21.5C26 21.8125 26.1875 22 26.5 22ZM20.5 22H21.5C21.75 22 22 21.8125 22 21.5V12.5C22 12.25 21.75 12 21.5 12H20.5C20.1875 12 20 12.25 20 12.5V21.5C20 21.8125 20.1875 22 20.5 22ZM8.5 22H9.5C9.75 22 10 21.8125 10 21.5V16.5C10 16.25 9.75 16 9.5 16H8.5C8.1875 16 8 16.25 8 16.5V21.5C8 21.8125 8.1875 22 8.5 22ZM14.5 22H15.5C15.75 22 16 21.8125 16 21.5V8.5C16 8.25 15.75 8 15.5 8H14.5C14.1875 8 14 8.25 14 8.5V21.5C14 21.8125 14.1875 22 14.5 22ZM31.5 26H2V4.5C2 4.25 1.75 4 1.5 4H0.5C0.1875 4 0 4.25 0 4.5V27C0 27.5625 0.4375 28 1 28H31.5C31.75 28 32 27.8125 32 27.5V26.5C32 26.25 31.75 26 31.5 26Z",
    fill: "#97AEB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/bar-chart.ced63c77.svg";
export { ForwardRef as ReactComponent };